import React, { useState, useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { node, string } from 'prop-types'
import { getParam } from '~/utils/get-param'

const propTypes = {
  children: node.isRequired,
  referrer: string,
}

const ReferrerContext = React.createContext()

const ReferrerProvider = ({ children, referrer = '' }) => {
  const state = useState(referrer)

  return (
    <ReferrerContext.Provider value={state}>
      {children}
    </ReferrerContext.Provider>
  )
}

ReferrerProvider.propTypes = propTypes

const useReferrer = () => {
  const [referrer] = useContext(ReferrerContext)

  return referrer
}

const useReferrerUpdate = () => {
  const location = useLocation()
  const [, setReferrer] = useContext(ReferrerContext)

  useEffect(() => {
    const referrerValue = getParam('referrer', location?.search)

    if (referrerValue) {
      setReferrer(referrerValue)
    }
  }, [location])
}

export { ReferrerContext, ReferrerProvider, useReferrer, useReferrerUpdate }
